module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-90.867f465b.svg";